import _ from 'lodash'
import ProductModel from '../Product'
import { PRODUCT_KEY } from '../../constants'
import styles from './styles.css'

const DeleteProductModel = props => {
  const { products } = props
  const isDeleteFirstRow = _.some(products, product => {
    return (_.get(product, PRODUCT_KEY.INDEX) === 0)
  })
  return (
    <ProductModel
      okText='移除商品'
      className='delete-prodcut-modal'
      {...props}
    >
      {
        isDeleteFirstRow
          ? (
            <>
              <p className={styles.row}>商品移除後，賣場第一張商品圖將被替換，</p>
              <p className={styles.row}>你確定要從賣場移除商品？</p>
              <br />
              <span className={styles.tip}>
                商品移除後，若需還原需重新提案
                <br />
                商品只會從此賣場移除，並不影響其他賣場顯示此商品
              </span>
            </>
          )
          : (
            <>
              <p className={styles.row}>商品移除後，復原需重新提案，</p>
              <p className={styles.row}>你確定要從賣場移除商品？</p>
              <br />
              <span className={styles.tip}>
                商品只會從此賣場移除，並不影響其他賣場顯示此商品
              </span>
            </>
          )
      }
    </ProductModel>
  )
}

export default DeleteProductModel
